import { render } from "./orderItemEdit.vue?vue&type=template&id=206815fc&scoped=true"
import script from "./orderItemEdit.vue?vue&type=script&lang=js"
export * from "./orderItemEdit.vue?vue&type=script&lang=js"

import "./orderItemEdit.vue?vue&type=style&index=0&id=206815fc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206815fc"]])

export default __exports__